export const select = ({ commit }, selection) => {
  return new Promise((resolve) => {
    if (!selection) selection = []
    if (selection && !Array.isArray(selection)) selection = [ selection ]
    commit('SET_SELECTION', selection)
    resolve(selection)
  })
}

export const selectAll = ({ getters, dispatch }, payload) => {
  if (!payload) return dispatch('unselect')
  return dispatch('select', getters.getEnableUIDs)
}

export const unselect = ({ commit }) => {
  return new Promise((resolve) => {
    commit('SET_SELECTION', [])
    resolve()
  })
}

export const emptyList = ({ commit }) => {
  return new Promise((resolve) => {
    commit('SET_LIST', [])
    resolve()
  })
}

export const setTarget = ({ commit }, target) => {
  return new Promise((resolve) => {
    commit('SET_TARGET', target)
    resolve(target)
  })
}
